<div id="int-users-main" class="w-full h-full">
  <app-internal-toolbar [title]="'internal.users.title' | translate">
    @if (api.hasPermission('create_users')) {
      <reactive-button
        actions
        [label]="'internal.users.newUser' | translate"
        icon="add"
        variant="outlined"
        (onClick)="editUser()"
      ></reactive-button>
    }
  </app-internal-toolbar>

  <div class="w-full h-fit overflow-auto">
    <p-table
      #usersTable
      [value]="users()"
      dataKey="_id"
      [paginator]="true"
      [rows]="10"
      [tableStyle]="{ 'min-width': '30rem' }"
      [rowsPerPageOptions]="[5, 10, 20]"
      [globalFilterFields]="[
        'username',
        'firstname',
        'lastname',
        'fullname',
        'schoolclass',
        'email',
        'technikEmail',
      ]"
    >
      <ng-template #caption>
        <div class="flex">
          <p-iconfield iconPosition="left" class="ml-auto">
            <p-inputicon>
              <mat-icon>search</mat-icon>
            </p-inputicon>
            <input
              pInputText
              type="text"
              (input)="usersTable.filterGlobal($event.target.value, 'contains')"
              [placeholder]="'general.searchPlaceholder' | translate"
            />
          </p-iconfield>
        </div>
      </ng-template>
      <ng-template #header>
        <tr>
          <th style="width: auto">{{ 'internal.users.username' | translate }}</th>
          <th style="width: auto">{{ 'internal.users.name' | translate }}</th>
          <th style="width: auto">{{ 'internal.users.schoolclass' | translate }}</th>
          <th style="width: auto">{{ 'internal.users.email' | translate }}</th>
          <th style="width: auto">{{ 'internal.users.active' | translate }}</th>
          <th style="width: auto">{{ 'general.edit' | translate }}</th>
        </tr>
        <tr class="desktop">
          <th>
            <p-columnFilter
              type="text"
              field="username"
              [placeholder]="'general.searchPlaceholder' | translate"
              filterOn="input"
              matchMode="contains"
            ></p-columnFilter>
          </th>
          <th>
            <p-columnFilter
              type="text"
              field="fullname"
              [placeholder]="'general.searchPlaceholder' | translate"
              filterOn="input"
              matchMode="contains"
            ></p-columnFilter>
          </th>
          <th>
            <p-columnFilter
              type="text"
              field="schoolclass"
              [placeholder]="'general.searchPlaceholder' | translate"
              filterOn="input"
              matchMode="contains"
            ></p-columnFilter>
          </th>
          <th>
            <p-columnFilter
              type="text"
              field="email"
              [placeholder]="'general.searchPlaceholder' | translate"
              filterOn="input"
              matchMode="contains"
            ></p-columnFilter>
          </th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template #body let-user>
        <tr>
          @if (loading()) {
            <td><p-skeleton /></td>
            <td><p-skeleton /></td>
            <td><p-skeleton /></td>
            <td><p-skeleton /></td>
            <td><p-skeleton /></td>
            <td><p-skeleton /></td>
          } @else {
            <td class="font-bold">{{ user.username }}</td>
            <td>{{ user.fullname }}</td>
            <td>{{ user.schoolclass }}</td>
            <td>{{ (user.email == '' ? 'internal.users.notSet' : user.email) | translate }}</td>
            <td>
              {{ (user.active ? 'internal.users.active' : 'internal.users.inactive') | translate }}
            </td>
            <td>
              <div class="flex flex-row">
                <button pButton [rounded]="true" [outlined]="true" (click)="editUser(user)">
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- <app-internal-requests-edit-dialog #editDialog></app-internal-requests-edit-dialog> -->
</div>
